import React from 'react';
import { TextField, Autocomplete } from '@mui/material';

export const STATE_OPTIONS = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA',
  'HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
  'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
  'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY',
];

const StateSelect = ({ label = 'State', value, onChange, fullWidth = true, required = false, disabled = false }) => {
  const options = React.useMemo(() => {
    const sortedStates = [...STATE_OPTIONS].sort();
    return [{ label: 'Blank', value: '' }, ...sortedStates.map((s) => ({ label: s, value: s }))];
  }, []);

  const selected = options.find((o) => o.value === (value || '')) || options[0];

  const handleChange = (_, newOption) => {
    const nextValue = newOption?.value ?? '';
    if (nextValue === '' || STATE_OPTIONS.includes(nextValue)) {
      onChange?.(nextValue);
    }
  };

  return (
    <Autocomplete
      options={options}
      value={selected}
      onChange={handleChange}
      disableClearable={required}
      autoHighlight
      fullWidth={fullWidth}
      disabled={disabled}
      // 选中 Blank 时，输入框显示为空白；下拉列表里仍然显示“Blank”
      getOptionLabel={(opt) => (opt?.value === '' ? '' : (opt?.label || ''))}
      isOptionEqualToValue={(opt, val) => opt?.value === val?.value}
      renderOption={(props, option) => (
        <li {...props}>
          {option.value === '' ? 'Blank' : option.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          margin="dense"
          disabled={disabled}
        />
      )}
    />
  );
};

export default StateSelect;

